const REGISTRY_URL = "https://preview-documents.btlsrv.com/api/links";
const REGISTRY_TOKEN = "preview-room-registry-2026-08-21";

const registeredRooms = new Set<string>();

const defaultRoomTitle = () => {
  const now = new Date();
  const pad = (value: number) => String(value).padStart(2, "0");
  return `Room ${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
};

export const registerRoomLink = async ({
  roomId,
  url,
  suggestedTitle,
}: {
  roomId: string;
  url: string;
  suggestedTitle: string | null;
}) => {
  if (registeredRooms.has(roomId)) {
    return;
  }

  // Reserve the room before any prompt/network await so concurrent collaboration
  // callbacks cannot register the same room twice.
  registeredRooms.add(roomId);

  const fallbackTitle = defaultRoomTitle();
  const title =
    window.prompt("Room title", suggestedTitle?.trim() || fallbackTitle)
      ?.trim()
      .slice(0, 200) || fallbackTitle;

  try {
    const response = await fetch(REGISTRY_URL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${REGISTRY_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ title, url }),
    });

    if (!response.ok) {
      throw new Error(`Registry returned ${response.status}`);
    }
  } catch (error) {
    registeredRooms.delete(roomId);
    // Registration must never prevent drawing or collaboration.
    console.warn("Could not register collaboration room", error);
  }
};
